export default "__VITE_ASSET__80c320b4__"